import React from 'react';
import {
  Wrapper,
  ShadowBackGround,
  ButtonWrapper
} from './styled';

interface Props {
  isOpen: boolean;
  children?: React.ReactNode;
  buttonClose?: React.ReactNode;
  handleClickOutSide?: Function;
  handleClickClose?: Function;
  right?: boolean;
  minWidth: number;
}

export const AsideModal: React.FC<Props> = ({
  isOpen,
  children,
  handleClickOutSide,
  buttonClose,
  right,
  minWidth
}) => {

  return(
    <React.Fragment>
      <Wrapper
        transition={isOpen}
        minWidth={minWidth}
        moveRight={right}
      >
        <ButtonWrapper>
          {buttonClose}
        </ButtonWrapper>
        {children}
      </Wrapper>
      <ShadowBackGround onClick={handleClickOutSide} transition={isOpen} />
    </React.Fragment>
  )
}
